import { useEffect, useRef, useState } from 'react'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/adminitem.module.scss'

export default function DonationLinkCopyButton({ auction }) {
  const [copied, setCopied] = useState(false)
  const copiedTimeout = useRef()

  useEffect(() => {
    return () => clearTimeout(copiedTimeout.current)
  }, [])

  const performCopy = async () => {
    const auctionCode = auction?.AuctionCode
    if (!auctionCode) return

    const donationLink = `${window.location.origin}/auctionhome?auctionId=${auctionCode}&donation=true`

    await navigator.clipboard.writeText(donationLink)
    setCopied(true)

    clearTimeout(copiedTimeout.current)
    copiedTimeout.current = setTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  if (!auction.HasDonation || auction.Status === "PREVIEW") return <></>

  return (
    <div className={css['donation-copy-container']}>
      <div className={css['copy-link-button-container']}>
        {copied && <p className={css['copied-alert']}>Copied to clipboard.</p>}
        <button type='button' className={`${themeCss['button']} ${themeCss['FilledBlue']}`} onClick={performCopy}>
          Copy Direct Donation Link
        </button>
      </div>
    </div>
  )
}
